"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_jsonschema_form_1 = __importDefault(require("react-jsonschema-form"));
const fieldTemplate_1 = __importDefault(require("./fieldTemplate"));
const arrayFieldTemplate_1 = __importDefault(require("./arrayFieldTemplate"));
const fields_1 = __importDefault(require("./fields"));
const widgets_1 = __importDefault(require("./widgets"));
const formTemplates_1 = require("../../formTemplates");
const media_1 = require("../../../utils/media");
const FormReader = ({ schema, uiSchema, formData, downloadFile = media_1.dummyDownloadFile, workflowContext }) => (jsx_runtime_1.jsx(react_jsonschema_form_1.default, Object.assign({ disabled: true, schema: schema, uiSchema: uiSchema, formData: formData, widgets: widgets_1.default, fields: fields_1.default, FieldTemplate: fieldTemplate_1.default, ObjectFieldTemplate: formTemplates_1.ObjectFieldTemplate, ArrayFieldTemplate: arrayFieldTemplate_1.default, showErrorList: false, formContext: {
        downloadFile,
        workflowContext
    } }, { children: jsx_runtime_1.jsx("button", { type: "submit", style: { display: 'none' } }, void 0) }), void 0));
FormReader.defaultProps = {
    workflowContext: undefined
};
exports.default = FormReader;
//# sourceMappingURL=index.js.map